import { Injectable } from '@angular/core';
import { UserRoles } from '@pragma/dto';

@Injectable({
    providedIn: 'root'
})
export class RoleService {
    private roles = [
        { label: 'admin', data: UserRoles.SuperAdmin },
        { label: 'super-admin', data: UserRoles.Admin },
        { label: 'end-user', data: UserRoles.SiteManager }
    ];

    private roleIdMapping: { [key: number]: UserRoles } = {
        1: UserRoles.SuperAdmin,
        2: UserRoles.Admin,
        3: UserRoles.SiteManager
    };

    public getRoles() {
        return this.roles;
    }

    getRoleLabelByRoleId(roleId: number): string | undefined {
        const userRole = this.roleIdMapping[roleId];
        return this.roles.find((role) => role.data === userRole)?.label;
    }
}
